const DEFAULT_MODEL = "gpt-5.2";

const MODEL_RATES_USD_PER_1M = {
    "gpt-5.2": { input: 1.75, output: 14.0 },
    "gpt-5.2-pro": { input: 10.5, output: 84.0 },
    "gpt-5.4": { input: 2.5, output: 15.0 },
    "gpt-5.4-mini": { input: 0.75, output: 4.5 },
    "gpt-4o": { input: 2.5, output: 10.0 },
    "gpt-4o-mini": { input: 0.15, output: 0.6 },
    "claude-sonnet-4-20250514": { input: 3.0, output: 15.0 },
    "claude-sonnet-4-5": { input: 3.0, output: 15.0 },
    "claude-sonnet-4-6": { input: 3.0, output: 15.0 },
    "claude-3-5-sonnet": { input: 3.0, output: 15.0 },
    "claude-3-sonnet": { input: 3.0, output: 15.0 },
    "claude-3-haiku": { input: 0.25, output: 1.25 },
    "anthropic.claude-sonnet": { input: 3.0, output: 15.0 },
};

export const DEFAULT_PRICING = { ...MODEL_RATES_USD_PER_1M[DEFAULT_MODEL] };

export function resolveModelPricing(model, overridePricing = {}) {
    if (!model) {
        return overridePricing[DEFAULT_MODEL] || DEFAULT_PRICING;
    }

    const normalized = String(model).toLowerCase();
    const direct = overridePricing[model] || MODEL_RATES_USD_PER_1M[model];
    if (direct) return direct;

    const matchedKey = Object.keys(MODEL_RATES_USD_PER_1M).find((key) => normalized.includes(key.toLowerCase()));
    if (matchedKey) return overridePricing[matchedKey] || MODEL_RATES_USD_PER_1M[matchedKey];

    return overridePricing[DEFAULT_MODEL] || DEFAULT_PRICING;
}

export function calculateCostUsd({ inputTokens = 0, outputTokens = 0, model, pricing = {} }) {
    const modelPricing = resolveModelPricing(model, pricing);
    const inputCost = (Number(inputTokens || 0) / 1_000_000) * Number(modelPricing.input || 0);
    const outputCost = (Number(outputTokens || 0) / 1_000_000) * Number(modelPricing.output || 0);
    return inputCost + outputCost;
}

export function formatUsd(amount) {
    return `$${Number(amount || 0).toFixed(4)}`;
}

export function formatNumber(value) {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(Number(value || 0));
}
